export enum LemonSubscriptionHistoryStatus {
  UNPAID = 'unpaid',
  PAID = 'paid',
  VOID = 'void',
  REFUNDED = 'refunded',
  PARTIAL_REFUNDED = 'partial_refunded',
  PENDING = 'pending',
}
